import React from 'react'
import LegalLayout, { Section, Para, Bullets, Accent } from '../components/LegalLayout'

const ShippingPolicy = () => {
  return (
    <LegalLayout title='Shipping & Delivery Policy' lastUpdated='25 June 2026'>
        <Para>
          This Shipping &amp; Delivery Policy explains how <Accent>Nilay Singh</Accent> delivers the
          services and digital products purchased through this website. As we provide software
          development and digital services, there is <Accent>no physical shipping</Accent> of goods
          involved.
        </Para>

        <Section heading='1. Nature of Delivery'>
          <Para>
            All offerings on this website are services or digital deliverables. Accordingly, no
            physical product is shipped or couriered to any address.
          </Para>
        </Section>

        <Section heading='2. Delivery Method & Timeline'>
          <Bullets items={[
            'Digital deliverables (such as source code, files, or access credentials) are delivered electronically via email or an agreed online channel.',
            'Service work begins after payment confirmation and as per the timeline agreed with you in writing.',
            'Typical delivery timelines for digital files range from immediately to a few business days, depending on the scope of the work.',
            'For custom development engagements, delivery dates are agreed individually before the project begins.'
          ]} />
        </Section>

        <Section heading='3. Delivery Confirmation'>
          <Para>
            Once a deliverable is sent or access is provided, we consider the delivery complete. Please
            ensure that the contact email you provide is accurate so that you receive your deliverables
            without delay.
          </Para>
        </Section>

        <Section heading='4. Failed or Delayed Delivery'>
          <Para>
            If you have not received your deliverable within the expected timeframe, please contact us
            using the details below and we will resolve the issue promptly.
          </Para>
        </Section>

        <Section heading='5. Contact Us'>
          <Para>For any questions about delivery, please reach us at:</Para>
          <Bullets items={[
            <><Accent>Name:</Accent> Nilay Singh</>,
            <><Accent>Email:</Accent> snilay011@gmail.com</>,
            <><Accent>Phone:</Accent> +91 9810237655</>,
            <><Accent>Address:</Accent> Shipra Riviera, Indirapuram, Ghaziabad, Uttar Pradesh, India</>
          ]} />
        </Section>
    </LegalLayout>
  )
}

export default ShippingPolicy
